module.exports = __webpack_public_path__ + "img/04.a7186764.jpg";